import { Skill } from '../../../types/skill'

interface SkillItemProps {
  skill: Skill
}

export default function SkillItem({ skill }: SkillItemProps) {
  return (
    <div className="[&:not(:last-child)]:pb-8 [&:not(:last-child)]:mb-8 [&:not(:last-child)]:border-b border-gray-200">
      <h3 className="text-lg font-semibold text-white-900">{skill.name}</h3>
      <div className="mt-3 space-y-3">
        <div className="flex items-center gap-3">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-sm">
              JD
            </div>
          </div>
          <span className="text-white-600">Endorsed by colleagues</span>
        </div>
        <div className="flex items-center gap-2 text-white-600 text-sm">
          <i className="fa-solid fa-users text-lg" />
          <span>{skill.endorsementCount} endorsements</span>
        </div>
      </div>
    </div>
  )
}
